import retry from '@/utils/retry';
import { MESSAGES } from '../utils/messages';
import { notifyError } from '../../module_user/uitls/notification-helper';
import redirect from '../../module_user/uitls/redirect';
import eliteService from '../../module_user/api/elite-service';
import api from '../api/api'
import { getChallengeEndTime, getFormattedDate, getWorkoutVideoDetailsSMB } from "../utils/genericFunctions";

const getState = () => {
    return {
        tenantData: null,
        videoList: [],
        loaderStatus: false,
        trainerDataLoading: false,
        fullPath: null,
        showLeaderboard: true,
        videoSMBMainVideo : [],
        videoSMBPrograms: [],
        videoSMBMyPrograms: [],
        videoSMBExtraVideo: [],
        teamAndContent: []
    };
}
const state = getState();

const mutations = {
    setVideoCount(state, count) {
        state.videoCount = count;
    },
    setProfileVideo(state, video) {
        state.profileVideo = video;
    },
    setVideos(state, data) {
        // const comingSoonVideos = data.filter((video) => video.isUpcoming);
        const videos = data.filter((video) => !video.isUpcoming);
        state.videoList = [...state.videoList, ...videos];
    },
    setSMBVideos(state, data){
        state.videoSMBMainVideo = [...state.videoSMBMainVideo, data.mainVideo];
        state.videoSMBExtraVideo = data.extraVideo;
        state.teamAndContent = data.teamAndContent;
    },
    setSMBPrograms(state, data){
        state.videoSMBPrograms = data;
    },
    setMyPrograms(state, data) {
        state.videoSMBMyPrograms = data;
    },
    setLoaderStatus(state, loaderStatus) {
        state.loaderStatus = loaderStatus;
    },
    setTenant(state, data) {
        state.tenantData = data;
    },
    setLoading(state, data) {
        state.trainerDataLoading = data;
    },
    setFullPath(state, fullPath){
        state.fullPath = fullPath;
    },
    setVideoList(state, videoList){
        state.videoList = videoList
    },
    setShowLeaderboard(state, showLeaderboard){
        state.showLeaderboard = showLeaderboard
    }
};

const getters = {
    getAllPrograms(state) {
        return state.videoSMBPrograms;
    },
    getMyPrograms(state) {
        return state.videoSMBMyPrograms;
    }
};

const actions = {
    async loadTenantData({ commit ,rootState}, tenantName) {
        commit('setLoading', true);
        let userData = rootState.userInfo
        if (tenantName === '' && userData?.corporate) {
            tenantName = userData.corporate?.redirect_url ? userData.corporate?.redirect_url : userData?.corporate?.organization;
        }
        try {
            const data = await eliteService.getTenantData(tenantName);
            commit('setTenant', data);
            commit('setLoading', false);
            return data;
        }
        catch (e) {
            try {
                await retry(e);
                const data = await eliteService.getTenantData(tenantName);
                commit('setTenant', data);
                commit('setLoading', false);
                return data;
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
        };
    },
    async getVideos({ commit }, payload) {
        try {
            const data = await api.getTenantVideos(payload.id, payload.page, payload.perPage);
            commit('setVideoCount', data.length);
            commit('setVideos', data);
            commit('setProfileVideo', data[0]);
            if(data.length <= 0){
                commit('setLoaderStatus', true);
            }
            return data;
        }
        catch (e) {
            try {
                await retry(e);
                const data = await api.getTenantVideos(payload.id, payload.page, payload.perPage);
                commit('setVideoCount', data.length);
                commit('setVideos', data);
                commit('setProfileVideo', data[0]);
                if(data.length <= 0){
                    commit('setLoaderStatus', true);
                }
                return data;
            } catch{
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
        }
    },
    async getSMBVideos({ commit }, payload) {
        try {
            const data = await api.getSMBVideos(payload.tenantId);
            if (data && data.data && data.data.videos) {
                commit('setSMBVideos', data.data.videos);
            }
            if (data && data.data && data.data.programs) {
                commit('setSMBPrograms', data.data.programs);
            }
            if (data && data.data && data.data.myPrograms) {
                commit('setMyPrograms', data.data.myPrograms);
            }
        }
        catch (e) {
            try {
                await retry(e);
                const data = await api.getSMBVideos(payload.tenantId);
                if (data && data.data && data.data.videos) {
                    commit('setSMBVideos', data.data.videos);
                }
                if (data && data.data && data.data.programs) {
                    commit('setSMBPrograms', data.data.programs);
                }
                if (data && data.data && data.data.myPrograms) {
                    commit('setMyPrograms', data.data.myPrograms);
                }
            } catch {
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
        }
    },
    setFullPath({commit}, fullPath){
        commit("setFullPath", fullPath);
    },
    setVideoList({commit}, videoList){
        commit("setVideoList", videoList);
    },
    setLoaderStatus({commit}, loaderStatus){
        commit("setLoaderStatus", loaderStatus);
    },
    setShowLeaderboard({commit}, showLeaderboard){
        commit("setShowLeaderboard", showLeaderboard);
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
